"use client";

import Image from "next/image";

interface AuthLoadingScreenProps {
  message?: string;
}

export function AuthLoadingScreen({ message = "Cargando..." }: AuthLoadingScreenProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center mesh-gradient p-4">
      <div className="flex flex-col items-center gap-6 animate-fade-in">
        <div className="relative w-14 h-14 rounded-2xl bg-white shadow-lg shadow-emerald-900/20 flex items-center justify-center">
          <Image src="/logo.ico" alt="MontMar" fill sizes="56px" className="object-contain p-2" />
        </div>
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-[3px] border-emerald-400/30 border-t-emerald-400 rounded-full animate-spin" />
          <p className="text-sm text-slate-300 font-medium tracking-wide">{message}</p>
        </div>
      </div>
    </div>
  );
}
